<!-->╔════╦═════════════════════════════════════════════════════════════════════════════════╗<- ->
<- ->║ PA ║                           Frequent Flyer Dashboard                              ║<- ->
<- ->╚════╩═════════════════════════════════════════════════════════════════════════════════╝<--->

<style scoped lang="less" src=":/PA/styles/ff_dashboard/ff_dashboard.less"></style>
<style lang="less" src=":/PA/styles/shared.less"></style>
<style>
    .loading.failure, .loading .failure {
        border: none;
    }
</style>

<script>
    import FrequentFlyerDashboard from "@/pages/ff_dashboard"
    import { importDefaults } from "@/helpers/imports"

    //  Use the same route map logic that's defined in /src, but apply our own custom components to it instead:
    import routes from '@/pages/ff_dashboard.routes.js'
    const components = importDefaults(require.context('./ff_dashboard', false))

    export default {
        name: "FrequentFlyerDashboard.PA",
        mixins: [FrequentFlyerDashboard],

        router: routes(components)
    }
</script>
